module.exports = __webpack_public_path__ + "images/174ab3e344c5f329f98ae55f78cf206d.svg";